import React, { useCallback, useContext, useState } from 'react';
import styled from 'styled-components';
import { TextArea } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useAccount from '@ubeya/shared/hooks/account/useAccount';
import ConfirmationModal from '@ubeya/shared-web/components/ConfirmationModal';

const Description = styled.div`
  margin-bottom: 10px;
`;

const Warning = styled.div`
  margin-top: 20px;
`;

const DeactivateEmployeeModal = ({ onClose, employee: { id, firstName, lastName }, updateEmployee }) => {
  const { t } = useContext(ConfigContext);
  const { accountId } = useAccount();

  const [reason, setReason] = useState('');
  const [isLodaing, setIsLoading] = useState(false);

  const onConfirm = useCallback(async () => {
    const updateParms = {
      accountId,
      employeeId: id,
      isActive: false,
      invalidateEmployee: false,
      deactivateReason: reason
    };

    await updateEmployee(updateParms);
    setIsLoading(false);

    onClose();
  }, [accountId, id, onClose, reason, updateEmployee]);

  return (
    <ConfirmationModal
      onConfirm={onConfirm}
      confirmText={t('turnToNonActive')}
      title={t('areYouSureDeactivateEmployeeName', { name: `${firstName} ${lastName}` })}
      loadingConfirm={isLodaing}
      onClose={onClose}
      usePortal>
      <Description>{t('deactivateReason', { name: `${firstName} ${lastName}` })}</Description>
      <TextArea value={reason} onChange={setReason} minRows={3} maxLength={1000} />
      <Warning>{t('deactivateReasonExplenation', { name: `${firstName} ${lastName}` })}</Warning>
    </ConfirmationModal>
  );
};
export default DeactivateEmployeeModal;
